import React from "react";

const VisionValues = ({ visionData = {} }) => {
  const { vision_title, vision_text } = visionData;

 const values = [
  {
    title: "Quality",
    desc: "We build carefully with durable materials and craftsmanship families can trust daily.",
    gradient: "from-blue-500 to-blue-600",
    icon: "🏅", // premium, trusted quality
  },
  {
    title: "On time delivery",
    desc: "Plans are realistic, milestones tracked, and handover happens on the date promised.",
    gradient: "from-indigo-500 to-indigo-600",
    icon: "⏱️", // punctuality & timelines
  },
  {
    title: "Customer first",
    desc: "We listen with care, respond quickly, and keep the process simple always.",
    gradient: "from-green-500 to-green-600",
    icon: "🤝", // partnership & priority
  },
  {
    title: "Fair dealing",
    desc: "Honest paperwork, straight answers, and prices that reflect true value for everyone.",
    gradient: "from-purple-500 to-purple-600",
    icon: "⚖️", // transparency & fairness
  },
  {
    title: "Safety",
    desc: "Safe sites, safe homes, and responsible practices that always protect every family.",
    gradient: "from-teal-500 to-teal-600",
    icon: "🛡️", // protection & safety
  },
  {
    title: "Community and environment",
    desc: "Neighbourhoods with green spaces and thoughtful use of water and power everywhere.",
    gradient: "from-emerald-500 to-emerald-600",
    icon: "🌳", // sustainability & community
  },
];


  return (
    <section className="bg-white relative overflow-hidden">
      {/* Vision section */}
      <section className="py-16 px-4 bg-[#CAE9F5] relative">
        <div className="container mx-auto max-w-5xl text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-700 mb-6">
            {vision_title || "Our Vision"}
          </h2>
          <p className="font-normal text-gray-900 text-base sm:text-lg md:text-xl max-w-4xl mx-auto leading-relaxed">
            {vision_text ||
              "To be a trusted name in real estate development by focusing on quality, innovation, and customer satisfaction."}
          </p>
        </div>

        {/* Background accents */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#305CDE] opacity-5 rounded-full -translate-y-32 translate-x-32"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#305CDE] opacity-5 rounded-full translate-y-24 -translate-x-24"></div>
      </section>

      {/* Values section */}
      <div className="py-16 sm:py-20 px-4 bg-gradient-to-br from-gray-50 via-white to-blue-50 relative">
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="text-center mb-10">
            <h3 className="text-3xl sm:text-4xl md:text-5xl text-[#2e6195] font-bold mb-4">
              Our Values
            </h3>
            <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#2e6195] to-transparent mx-auto rounded-full"></div>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {values.map((v, i) => (
              <div
                key={i}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-blue-200 relative overflow-hidden transform hover:-translate-y-2"
              >
                <div
                  className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${v.gradient} opacity-5 rounded-bl-full`}
                ></div>
                <div className="relative z-10 flex flex-col justify-center h-full p-8">
                  <div className="flex items-center gap-4 mb-4">
                    <div
                      className={`flex-shrink-0 w-16 h-16 rounded-xl bg-gradient-to-br ${v.gradient} text-white flex items-center justify-center shadow-lg`}
                    >
                      <span className="text-2xl">{v.icon}</span>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">{v.title}</h4>
                  </div>
                  <p className="text-gray-600 text-base leading-relaxed">
                    {v.desc}
                  </p>
                </div>
                <div
                  className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${v.gradient} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left`}
                ></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionValues;
